import { ResponsiveValue } from './types';

export const testResponsiveValue = <T extends ResponsiveValue<unknown>>(
  predicate: (val: T) => boolean
) => (val: T) => (Array.isArray(val) ? val.some(predicate) : predicate(val));
